<template>
  <b-container class="my-4" fluid>
    <b-row>
      <b-col class="mx-5">
        <page-title title="Execute Model" :subtitle="`${model_name} / ${model_description}`">
        </page-title>
        <b-tabs>
          <b-tab title="Execute">
            <b-row>
              <b-col cols="12">
                <b-form-textarea
                  id="textarea"
                  placeholder="Enter execution inputs as JSON"
                  rows="6"
                  max-rows="10"
                  v-model="executionInputsJson"
                  class="mt-3 mb-3"
                ></b-form-textarea>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group class="d-flex justify-content-end text-right">
                  <!--<span class="mr-2"> Target Platform: </span>
                  <b-form-select
                    v-model="selectedAdes"
                    :options="adesOptions"
                    style="width: 250px"
                  ></b-form-select>-->
                  <b-button
                    class="execute-button"
                    @click="execute()"
                    type="submit"
                    variant="success"
                  >
                    <fa-icon class="mt-1 mr-2 float-left" icon="bolt" />
                    <span v-if="executing">Sending request...</span>
                    <span v-else>Execute</span>
                  </b-button>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import backendService from "@/api/asb/services/backend";
import PageTitle from "@/components/share/PageTitle";
import { mapState } from "vuex";

export default {
  name: "ModelExecutePage",
  components: {
    PageTitle
  },
  data() {
    return {
      application_id: "",
      collection_id: "",
      loading: true,
      appInfo: {},
      updating: false,
      executing: false,
      executionInputsJson: "",
      adesOptions: [
        {
          text: "Default",
          value: "local"
        }
      ],
      selectedAdes: "local"
    };
  },
  created() {
    this.application_id = this.$route.params.app_id;
    this.collection_id = this.$route.params.id;
    this.getAppInfo();
  },
  methods: {
    getAppInfo() {
      backendService
        .describeModel(this.collection_id, this.application_id)
        .then(data => this.setInfo(data))
        .catch(error => backendService.handleError(error))
        .finally(() => (this.loading = false));
    },
    setInfo(appInfo) {
      this.appInfo = appInfo;
      console.log(this.appInfo);
      //      this.modelName = this.setModelName();
      //      this.modelDescription = this.setModelDescription();
    },
    execute() {
      this.executing = true;
      console.log("Executing with: " + this.executionInputsJson);
      backendService
        .startModelExecution(this.collection_id, this.application_id, this.executionInputsJson)
        .then(() => {
          console.log("execution started!");
          this.$router.push("/monitoring/applications");
        });
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    model_name() {
      let modelName = "model";
      if (this.appInfo.properties) {
        modelName = this.appInfo.properties.name
          ? this.appInfo.properties.name
          : this.appInfo.properties.title
          ? this.appInfo.properties.title
          : this.appInfo.id
          ? this.appInfo.id
          : "model";
      }
      return modelName;
    },
    model_description() {
      let modelDescription = "model";
      if (this.appInfo.properties) {
        modelDescription = this.appInfo.properties.abstract
          ? this.appInfo.properties.abstract
          : this.appInfo.description
          ? this.appInfo.description
          : "model";
      }
      return modelDescription;
    }
  },
  filters: {
    pretty: function(value) {
      return JSON.stringify(value, null, 2);
    },
    makeTitle: function(value) {
      const title = value.replace("_", " ");
      let title2 = title.charAt(0).toUpperCase() + title.slice(1);
      if (title2 == "Doi") {
        title2 = "DOI";
      }
      return title2;
    }
  }
};
</script>

<style></style>
